import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  { q: "What happens during a session?", a: "We begin with a brief check-in, then you'll lie comfortably (clothed) as I work along twelve access points on your spine. Most sessions weave breath, gentle touch, and stillness. Sessions end with rest and integration." },
  { q: "Is Spinal Flow painful?", a: "Not at all. There is no cracking, adjusting, or force. The work is gentle — sometimes profoundly so. Many clients drift in and out of a meditative state." },
  { q: "How long is each session?", a: "Home Sessions run 75 minutes. Consultations and follow-up care are 45 minutes. We protect the rhythm — never rushed." },
  { q: "Who can benefit?", a: "Anyone holding stress, tension, or stored emotion. The work is suitable for most bodies — including pregnancy, post-partum, and elders. Please flag any acute injury in the booking notes." },
  { q: "What payment methods are accepted?", a: "Secure card payments via Stripe, including Apple Pay and Google Pay. You may also choose to pay after the session — cash, transfer, or card on the day." },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-24 md:py-32">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="text-center reveal mb-12">
          <p className="text-xs uppercase tracking-[0.25em] text-secondary mb-4">Gentle answers</p>
          <h2 className="font-serif text-4xl md:text-5xl">Frequently asked</h2>
        </div>
        <div className="reveal">
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="rounded-2xl border border-border/60 bg-card/40 px-6 data-[state=open]:bg-card/70"
              >
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="font-serif text-xl md:text-2xl hover:no-underline py-5 text-left">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed text-base pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
